import React from 'react';
import { Dialog, DialogTitle, Button } from '@mui/material';
import {
	useNotify,
	useRefresh,
	SimpleForm,
	ReferenceInput,
	SelectInput,
	Toolbar,
	SaveButton,
	useCreate,
	required,
	Identifier,
	AutocompleteInput,
} from 'react-admin';
import { billingAccountUserRoleChoices } from '../../../Services/billingAccountUser';

interface BillingAccountUserModalCreateProps {
	open: boolean;
	handleClose: () => void;
	billingAccountId?: Identifier;
}

const BillingAccountUserModalCreate: React.FC<
	BillingAccountUserModalCreateProps
> = ({ open, handleClose, billingAccountId }) => {
	const notify = useNotify();
	const refresh = useRefresh();
	const [create] = useCreate();

	const handleSave = (data: any) => {
		// Ajoutez l'ID du User aux données du formulaire
		create(
			'billing-account-users',
			{
				data: {
					billingAccountId: billingAccountId,
					userId: data.userId,
					role: data.role,
				},
			},
			{
				onSuccess: () => {
					refresh();
					notify('Bill Account user created successfully');
					handleClose();
				},
				onError: (error: any) => {
					notify(`Error: ${error.message}`, { type: 'error' });
				},
			}
		);
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle>Add Billing Account to user</DialogTitle>

			{/* Formulaire pour ajouter un projet utilisateur */}
			<SimpleForm
				onSubmit={handleSave} // Utilisation de handleSave pour soumettre le formulaire
				toolbar={
					<Toolbar style={{ justifyContent: 'space-between' }}>
						<SaveButton label="Save" />
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</Toolbar>
				}
			>
				<ReferenceInput
					label="User"
					source="userId"
					reference="users"
					perPage={25} // limite les résultats pour éviter la surcharge
					filterToQuery={(searchText: string) => ({ q: searchText })}
				>
					<AutocompleteInput optionText="name" validate={required()} />
				</ReferenceInput>

				<SelectInput
					source="role"
					choices={billingAccountUserRoleChoices}
					optionText="name"
					optionValue="id"
				/>
			</SimpleForm>
		</Dialog>
	);
};

export default BillingAccountUserModalCreate;
